import { RESOURCES_CONSTANTS } from "config/constants";
import PCIcon from "icons/PCIcon";
import PeopleIcon from "icons/PeopleIcon";
import TabletIcon from "icons/TabletIcon";

export const INIT_FILTER_FIELDS = {
    campusId: 0,
    libraryId: 0,
    resourceTypeId: "",
    date: -1
};
export const INIT_CURRENT_FILTER_FIELD = {
    id: "",
    name: ""
};
const { RESOURCE_TYPES_IDS } = RESOURCES_CONSTANTS;
export const RESOURCE_TEXT_LIST = {
    [RESOURCE_TYPES_IDS.TABLET]: {
        minus: {
            singular: "tablet",
            plural: "tablets"
        },
        mayus: {
            singular: "TABLET",
            plural: "TABLETS"
        },
        capital: {
            singular: "Tablet",
            plural: "Tablets"
        }
    },
    [RESOURCE_TYPES_IDS.PC]: {
        minus: {
            singular: "computadora",
            plural: "computadoras"
        },
        mayus: {
            singular: "COMPUTADORA",
            plural: "COMPUTADORAS"
        },
        capital: {
            singular: "Computadora",
            plural: "Computadoras"
        }
    },
    [RESOURCE_TYPES_IDS.GROUP_ROOM]: {
        minus: {
            singular: "sala grupal",
            plural: "salas grupales"
        },
        mayus: {
            singular: "SALA GRUPAL",
            plural: "SALA GRUPALES"
        },
        capital: {
            singular: "Sala grupal",
            plural: "Salas grupales"
        }
    }
};
export const FILTER_STYLE_PROPS = {
    CUSTOM_SELECT: {
        width: {
            container: "200px",
            containerSelect: "100%"
        },
        minWidth: "200px"
    },
    CUSTOM_BUTTON: {
        width: "95px",
        size: "small"
    }
};

export const RESOURCE_TYPE_ICONS = {
    [RESOURCE_TYPES_IDS.TABLET]: <TabletIcon/>,
    [RESOURCE_TYPES_IDS.PC]: <PCIcon/>,
    [RESOURCE_TYPES_IDS.GROUP_ROOM]: <PeopleIcon/>
};
export const ERROR_GET_SERVICES = {
    NON_BUSINESS_DAY: "DIA_NO_HABIL"
};
export const FORM_ACTION_ERRORS = {
    FUTURE_RESERVATIONS: "RESERVAS_FUTURAS"
};